import { CustomIcons } from '@/screens/Tickets/utils/customIcons';
import { MenuItem } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { usePropertyMenu } from '.';
import { useUpdatePropertyForm } from '../../../Forms/UpdateProperty';

function EditProperty() {
  const { t } = useTranslation();
  const openForm = useUpdatePropertyForm();
  const { property } = usePropertyMenu();

  return (
    <MenuItem
      fontSize="lg"
      onClick={() => openForm({ propertyId: property.id })}
      icon={<CustomIcons.PencilIcon fontSize="lg" />}
    >
      {t('actions.edit_property')}
    </MenuItem>
  );
}

export const PropertyOptions = {
  EditProperty,
};
